module.exports = __webpack_public_path__ + "static/img/day_report_fail.4481e72c.png";